import { Space, Slider, Modal, Progress, Popover } from "antd";
import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
import { useNavigate } from "react-router-dom";
import {
  ArrowLeftOutlined,
  DeleteOutlined,
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  SwapOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { DatePicker, Radio } from "antd";
import React, { useState, useEffect, useRef } from "react";
import { get, post, remove } from "../Libraries/Ajax/HttpService";
import { Spin, Tag, Checkbox } from "antd";
import { DownOutlined } from "@ant-design/icons";
// import Multiselect from 'multiselect-react-dropdown';
import "bootstrap/dist/css/bootstrap.min.css";
import { Table } from "react-bootstrap";
import moment from "moment";
import { toast } from "react-toastify";
import Form from "react-bootstrap/Form";
// import Select from 'react-select';
import { Select } from "antd";
import download from "../assets/images/download.svg";
import { saveAs } from "file-saver";
// import { parse } from 'json2csv';

import {
  XAxis,
  YAxis,
  Legend,
  CartesianGrid,
  Line,
  Tooltip,
  LineChart,
  ResponsiveContainer,
} from "recharts";
import back from "../assets/images/back.svg";
import deleteIcon from "../assets/images/delete.svg";
import edit from "../assets/images/edit.svg";
import dayjs from "dayjs";
import { useDistrict } from "../utils/DistrictContext";
function Notificationss() {
  var mcdata = JSON.parse(localStorage.getItem("MCData"));
  const navigate = useNavigate();
  const { RangePicker } = DatePicker;
  const plainArray = [
    "85827",
    "86287",
    "86288",
    "47200",
    "96882",
    "47201",
    "1836584",
  ];
  const [value, setValue] = useState(1);
  const plainOptions = ["All Daily", "All Weekly"];
  const plainOption = ["Daily", "Weekly"];
  const [selected, setSelected] = useState("");
  const [accountname, setAccountname] = useState("");
  const [register, setRegister] = useState("");
  const [open, setOpen] = useState(false);
  const [opens, setOpens] = useState(false);
  const [openss, setOpenss] = useState(false);
  const [checked, setChecked] = useState("None");
  const [checkednew, setCheckednew] = useState(false);
  const [weekly, setWeekly] = useState(false);
  const [monthly, setMonthly] = useState(false);
  const [weeklys, setWeeklys] = useState(false);
  const [monthlys, setMonthlys] = useState(false);
  const [loading, setLoading] = useState(false);
  const [first, setFirst] = useState(false);
  const [modalStatus, setModalStatus] = useState("");
  const [data, setdata] = useState([]);
  const [datass, setdatass] = useState([]);
  const [date, setdate] = useState();
  const [datas, setdatas] = useState([]);
  const [second, setSecond] = useState(false);
  const [startMonth, setstartMonth] = useState("");
  const [endMonth, setendMonth] = useState("");
  const [csvData, setcsvData] = useState([]);
  const [dates, setDates] = useState([null, null]);
  const [aggregateValue, setaggregateValue] = useState("25");
  const [aggData, setaggData] = useState([
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
  ]);
  const [progress, setProgress] = useState(0);
  const [startDownload, setstartDownload] = useState(0);
  const selectedDistrict = useDistrict();
  const districtId = selectedDistrict?.selectedDistrict;
  const isFB151 = districtId === "FB151";
  // useEffect(() => {
  //     const isMizuWatch = window.location.href.includes("mizuwatch.com");
  //     document.title = isMizuWatch ? "MizuWatch" : "MizuSmart";
  //   }, []);
  useEffect(() => {
    var user = JSON.parse(localStorage.getItem("MCData"));
    var userid = user?.userid;
    if (second === false)
      get(`apis/user_notified/list?user_id=${userid}`).then((response) => {
        setTimeout(() => {
          setdatass(response.data.data);
          setMonthlys(response.data.data.audit_report_monthly);
          setWeeklys(response.data.data.audit_report_weekly);
          setMonthly(response.data.data.dashboard_monthly);
          setWeekly(response.data.data.dashboard_weekly);
          setChecked(response.data.data.notification_interval);
          setSecond(true);
        }, 1000);
      });
  }, [second]);
  useEffect(() => {
    if (csvData.length > 0) {
      setProgress(100);
    } else {
      const timer = setInterval(() => {
        if (startMonth && csvData.length == 0) {
          setProgress((prevProgress) =>
            prevProgress >= 90 ? 90 : prevProgress + 15
          );
        } else {
          setProgress(0);
        }
      }, 800);

      return () => {
        clearInterval(timer);
      };
    }
  }, [startDownload]);

  useEffect(() => {
    if (startDownload) {
      let aggnum = aggregateValue;
      if (aggregateValue === "") {
        aggnum = "25";
      }

      if (startMonth && endMonth && endMonth !== "") {
        console.log("api call ");
        get(
          `apis/water_usage_report?report_range=all&end_date=${endMonth}&start_date=${startMonth}&aggregate_on=${aggnum}`
        ).then((response) => {
          if (response.status === 200) {
            setTimeout(() => {
              const data_temp = response.data.data;
              setcsvData(response.data.data);
              console.log("csv data is ,", data_temp);
              const headers = data_temp[0];
              const rows = data_temp.slice(1);
              const escapeValue = (value) => {
                if (typeof value === "string") {
                  if (value.includes(",")) {
                    value = `"${value}"`;
                  }
                }
                return value;
              };
              const csvContent = [headers, ...rows]
                .map((e) => e.map(escapeValue).join(","))
                .join("\n");
              const blob = new Blob([csvContent], {
                type: "text/csv;charset=utf-8;",
              });
              const link = document.createElement("a");
              const url = URL.createObjectURL(blob);
              link.href = url;
              let temp_agg_val = aggregateValue;
              if (aggregateValue == "") {
                temp_agg_val = "25";
              }
              let csv_file_name =
                "Report_" +
                String(startMonth) +
                "_to_" +
                String(endMonth) +
                "_aggregated_by_" +
                String(temp_agg_val) +
                "_of_month.csv";
              csv_file_name = csv_file_name.replace(/\s/g, "_");
              link.setAttribute("download", csv_file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(url);
              setcsvData([]);
              const emptyStr = "";
              setstartMonth(emptyStr);
              setendMonth(emptyStr);
              setDates([null, null]);
              setaggregateValue("25");
              toast.info("Success! The report file has been downloaded.");
              setstartDownload(false);
            }, 1000);
          }
        });
      }
    }
  }, [startDownload]);
  const downclick = (e) => {
    if (startMonth && endMonth && aggregateValue) {
      setstartDownload(true);
    } else {
      toast.info("Date selection is required. Please choose the dates.");
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };
  const handleCancels = () => {
    setOpens(false);
  };
  const handleCancelss = () => {
    setOpenss(false);
  };
  const weeklyChange = (e) => {
    setWeekly(e.target.checked);
    var user = JSON.parse(localStorage.getItem("MCData"));
    var userid = user?.userid;
    post(
      `apis/user_notified?user_id=${userid}&option=dashboard_weekly&value=${e.target.checked}`
    ).then((response) => {});
  };
  const monthlyChange = (e) => {
    setMonthly(e.target.checked);
    var user = JSON.parse(localStorage.getItem("MCData"));
    var userid = user?.userid;
    post(
      `apis/user_notified?user_id=${userid}&option=dashboard_monthly&value=${e.target.checked}`
    ).then((response) => {});
  };

  const weeklyChanges = (e) => {
    setWeeklys(e.target.checked);
    var user = JSON.parse(localStorage.getItem("MCData"));
    var userid = user?.userid;
    post(
      `apis/user_notified?user_id=${userid}&option=audit_report_weekly&value=${e.target.checked}`
    ).then((response) => {});
  };
  const monthlyChanges = (e) => {
    setMonthlys(e.target.checked);
    var user = JSON.parse(localStorage.getItem("MCData"));
    var userid = user?.userid;
    post(
      `apis/user_notified?user_id=${userid}&option=audit_report_monthly&value=${e.target.checked}`
    ).then((response) => {});
  };
  useEffect(() => {
    var user = JSON.parse(localStorage.getItem("MCData"));
    var userid = user?.userid;
    get(`apis/accountbased_meters_list?user_id=${userid}`).then((response) => {
      setdata(response.data.data);
      console.log(data);
    });
  }, [open]);
  useEffect(() => {
    var user = JSON.parse(localStorage.getItem("MCData"));
    var userid = user?.userid;
    // if (first === false)
    get(`apis/notification_meter_settings_list?user_id=${userid}`).then(
      (response) => {
        setdatas(response.data.data);
        setFirst(true);
      }
    );
  }, [selectedDistrict]);

  const handleOk = async () => {
    const user = JSON.parse(localStorage.getItem("MCData"));
    const userid = user?.userid;

    if (!date) {
      toast.info("Please choose a date");
      return;
    }
    if (!selected) {
      toast.info("Please choose a Meter");
      return;
    }

    const temp_date = date;

    try {
      await post(
        `apis/notification_meters_main_update?user_id=${userid}&weekly=true&monthly=true&meter_id=${selected}&account_name=${encodeURIComponent(
          accountname
        )}&end_date=${temp_date}&register_number=${register || ""}`
      );

      toast.success("Meter updated successfully");
      // Fetch latest data instead of reload
      const response = await get(
        `apis/notification_meter_settings_list?user_id=${userid}`
      );
      setdatas(response.data.data);
      setOpen(false);
      setOpens(false);
    } catch (err) {
      toast.error("Error updating meter");
    }
  };

  useEffect(() => {}, [checked]);

  const handleDeleteClicks = async () => {
    const user = JSON.parse(localStorage.getItem("MCData"));
    const userid = user?.userid;

    try {
      await remove(
        `apis/notification_meters_remove?meter_id=${selected}&user_id=${userid}&register_number=${register}`
      );

      toast.error("Removed Settings Successfully", { autoClose: 3000 });

      // Update the list locally instead of reload
      setdatas((prev) => prev.filter((item) => item.meter_id !== selected));
      setOpenss(false);
    } catch (err) {
      toast.error("Error removing meter");
    }
  };

  const handleDeleteClick = (id, register) => {
    setOpenss(true);
    setSelected(id);
    setRegister(register);
  };

  const onSelect = (selectedList, selectedItem) => {};

  const onRemove = (selectedList, removedItem) => {};
  const handleOutlierpageclick = () => {
    navigate("/outliers");
  };
  const handleNotificationclick = () => {
    navigate("/alert");
  };
  const onChange = (date) => {
    if (date) {
      console.log("Date: ", date.utc().format("YYYY-MM-DD HH:mm:ss"));
      setdate(date.utc().format("YYYY-MM-DD"));
      console.log(date);
    } else {
      console.log("Clear");
    }
  };
  const modalclick = (event) => {
    setOpen(true);
  };
  const modalclicks = (id, name, register, date) => {
    setOpens(true);
    setSelected(id);
    console.log("date by sachin ", date);
    setdate(date);
    setAccountname(name);
    setRegister(register);
    console.log(date);
  };

  const downloadCSV = () => {
    if (csvData.length === 0) {
      toast.info("Choose the dates .");
      return;
    }

    const headers = csvData[0];

    const rows = csvData.slice(1);

    const csvContent = [headers, ...rows].map((e) => e.join(",")).join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.href = url;
    let temp_agg_val = aggregateValue;
    if (aggregateValue == "") {
      temp_agg_val = "25";
    }
    let csv_file_name =
      "Report_" +
      String(startMonth) +
      "_to_" +
      String(endMonth) +
      "_aggregated_by_" +
      String(temp_agg_val) +
      "_of_month.csv";
    csv_file_name = csv_file_name.replace(/\s/g, "_");
    link.setAttribute("download", csv_file_name);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    setcsvData([]);
    const emptyStr = "";
    setstartMonth(emptyStr);
    setendMonth(emptyStr);
    setDates([null, null]);
    setaggregateValue("25");
    toast.info("Success! The report file has been downloaded.");
  };

  const onchangeMonthpicker = (value, dateString) => {
    setstartMonth(dateString[0]);
    setendMonth(dateString[1]);
    setcsvData([]);
    setDates(value);
  };
  const onAggregateset = (event) => {
    const aggValue = event.target.value;

    setaggregateValue(aggValue);
    setcsvData([]);
  };

  const onActiveChange = (event) => {
    setChecked(event.target.value);
    var user = JSON.parse(localStorage.getItem("MCData"));
    var userid = user?.userid;
    var status;
    if (event.target.value == "weekly") {
      status = true;

      post(
        `apis/user_notified?user_id=${userid}&option=meter_status&types=weekly&value=true`
      ).then((response) => {});
    } else if (event.target.value == "daily") {
      post(
        `apis/user_notified?user_id=${userid}&option=meter_status&types=daily&value=true`
      ).then((response) => {});
    } else if (event.target.value == "None") {
      post(
        `apis/user_notified?user_id=${userid}&option=meter_status&types=None&value=true`
      ).then((response) => {});
    }
  };

  const onRedirection = (event) => {
    navigate(-1);
  };
  const onMouseClick = (event) => {
    const selectedIndex = event.target.options.selectedIndex;
    setSelected(event.target.options[selectedIndex].getAttribute("data-key"));
    setRegister(event.target.options[selectedIndex].getAttribute("datas"));
    setAccountname(event.target.value);
    console.log("test", event.target.value);
  };
  return (
    <>
      {/* <head>
        <title> {window.location.href.indexOf("mizuwatch.com") > -1?"MizuWatch":"MizuSmart"}  </title></head> */}
      <Header />
      <Main>
        <div>
          <div class="row">
            <div class="col-md-12">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex ">
                  <img
                    src={back}
                    alt=""
                    style={{ width: "10px", cursor: "pointer" }}
                    onClick={onRedirection}
                  />
                  <div className="d-flex align-items-center">
                    <div
                      className="new-box-padding   align-self-center c-pointer "
                      style={{
                        borderBottom: "2px solid #ccc",
                      }}
                      onClick={handleNotificationclick}
                    >
                      Notification
                    </div>
                    {mcdata.mcdatas.type === "U" &&
                    mcdata.mcdatas.type === "U" ? (
                      ""
                    ) : (
                      <>
                        <div
                          className=""
                          style={{
                            width: "2px",
                            height: "25px",
                            background: "#ccc",
                          }}
                        ></div>
                        <div
                          className="new-box-padding  text-blue  align-self-center c-pointer"
                          style={{
                            borderBottom: "2px solid #1998f0",
                            borderRadius: "0",
                          }}
                        >
                          Reports and Alerts
                        </div>{" "}
                      </>
                    )}

                    <div
                      className=""
                      style={{
                        width: "2px",
                        height: "25px",
                        background: "#ccc",
                      }}
                    ></div>
                    <div
                      className="new-box-padding   align-self-center c-pointer "
                      style={{
                        borderBottom: "2px solid #ccc",
                      }}
                      onClick={handleOutlierpageclick}
                    >
                      Data Outliers
                    </div>
                  </div>
                </div>
              </div>

              <div class="bottom-layout mt-4">
                <div class="card-body">
                  <div class="row ">
                    <div class="row mb-3 m-0 pt-0 notification-style">
                      <div className="col-lg-12 mb-3">
                        
                        <h4 class="text-blue mb-0 fw-bold">Reports</h4>
                        
                      </div>
                      <div class="col-md-4">
                          <div class="d-flex justify-content-start align-items-center gap-4">
                        <h6 className="total-flow-font-size mb-0">
                          <b>Dashboard Report</b>
                        </h6>
                        	<Space className="me-3">
                                <Popover
                                  trigger="click"
                                  content={
                                    <div
                                      style={{
                                        width: "250px",
                                        textAlign: "left",
                                      }}
                                    >
                                     Enable to receive Dashboard Reports showing summary information exactly as presented on the dashboard.
                                    </div>
                                  }
                                  placement="top"
                                  getPopupContainer={(trigger) =>
                                    trigger.parentElement
                                  }
                                >
                                  <InfoCircleOutlined
                                    onClick={(e) => e.stopPropagation()} 
                                    style={{
                                      color: "#1890ff",
                                      cursor: "pointer",
                                      marginTop: "8px",
                                    }}
                                  />
                                </Popover>
                              </Space>
                        </div>
                        <div class="form-check ps-0 d-flex align-items-center mt-3">
                          {weekly === true ? (
                            <>
                              <Checkbox
                                checked={weekly}
                                onChange={weeklyChange}
                              >
                                <span className="ms-2">
                                  <b>Weekly</b>
                                </span>
                              </Checkbox>
                              <br />
                            </>
                          ) : (
                            <>
                              <Checkbox
                                checked={weekly}
                                onChange={weeklyChange}
                              >
                                <span className="ms-2">Weekly</span>
                              </Checkbox>{" "}
                              <br />
                            </>
                          )}
                          {monthly === true ? (
                            <>
                              <Checkbox
                                checked={monthly}
                                onChange={monthlyChange}
                              >
                                <span className="ms-2">
                                  <b>Monthly</b>
                                </span>
                              </Checkbox>
                              <br />
                            </>
                          ) : (
                            <>
                              <Checkbox
                                checked={monthly}
                                onChange={monthlyChange}
                              >
                                <span className="ms-2">Monthly</span>
                              </Checkbox>
                              <br />
                            </>
                          )}
                        </div>
                      </div>
                      {openss === true ? (
                        <Modal
                          open={openss}
                          onOk={handleDeleteClicks}
                          // confirmLoading={confirmLoading}
                          onCancel={handleCancelss}
                          centered="true"
                        >
                          <h5 className="text-left pt-4">
                            Are you sure you want to permanently remove this
                            item?
                          </h5>
                        </Modal>
                      ) : (
                        ""
                      )}
                      {open === true ? (
                        <Modal
                          width={800}
                          title=""
                          open={open}
                          onOk={handleOk}
                          onCancel={handleCancel}
                          centered="true"
                          okText="Add"
                        >
                          <>
                            <form>
                              <div class="row mb-3 d-flex justify-content-between algn-items-center">
                                <div className="col-lg-12 mb-4">
                                  <h4 class="text-blue mb-0 fw-bold">
                                    Add Meter
                                  </h4>
                                </div>
                                <div class="col-md-6 mt-1">
                                  <h6 className="w-100 text-blue total-flow-font-size">
                                    Meter
                                  </h6>
                                  <div class="form-check ps-0">
                                    <select
                                      name="All meters"
                                      id="selector"
                                      className="box meter-placeholder w-100"
                                      onChange={onMouseClick}
                                    >
                                      <option value=""> Please Select</option>
                                      {data.map((result, key) => (
                                        <option
                                          key={key}
                                          value={result.account_name}
                                          data-key={result.meter_id}
                                          datas={result.register_number}
                                        >
                                          {" "}
                                          {result.meter_id}
                                          {result.register_number
                                            ? "," + result.register_number
                                            : ""}
                                          -{result.account_name}{" "}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>

                                <div class="col-md-6 mt-1">
                                  <h6 className="w-100 text-blue total-flow-font-size ">
                                    End Date
                                  </h6>
                                  <div className="notification ">
                                    <DatePicker
                                      className="pickdisplay w-100 px-2"
                                      getPopupContainer={(triggerNode) => {
                                        return triggerNode.parentNode;
                                      }}
                                      presets={[
                                        {
                                          label: "Yesterday",
                                          value: dayjs().add(-1, "d"),
                                        },
                                        {
                                          label: "Last Week",
                                          value: dayjs().add(-7, "d"),
                                        },
                                        {
                                          label: "Last Month",
                                          value: dayjs().add(-1, "month"),
                                        },
                                      ]}
                                      disabledDate={(current) => {
                                        return current && current < Date.now();
                                      }}
                                      // defaultValue={ moment(Date.now()+3600 * 1000 * 24 * 30)}
                                      onChange={onChange}
                                    />
                                  </div>
                                </div>
                              </div>
                            </form>
                          </>
                        </Modal>
                      ) : (
                        ""
                      )}
                      {opens === true ? (
                        <Modal
                          width={800}
                          title=""
                          open={opens}
                          onOk={handleOk}
                          onCancel={handleCancels}
                          centered="true"
                          okText="Save"
                        >
                          <>
                            <div class="row mb-3 d-flex justify-content-between algn-items-center">
                              <div className="col-lg-12 mb-4">
                                <h4 class="text-blue mb-0 fw-bold">
                                  Edit Meter
                                </h4>
                              </div>
                              <div class="col-md-6 mt-1">
                                <h6 className="w-100 text-blue total-flow-font-size">
                                  Meter
                                </h6>
                                <div class="form-check ps-0 meter-edit">
                                  <label className="ms-3">
                                    {selected}
                                    {register ? "," + register : ""}
                                  </label>
                                </div>
                              </div>
                              <div class="col-md-6 mt-1">
                                <h6 className="w-100 text-blue total-flow-font-size">
                                  Account Name
                                </h6>
                                <div class="form-check ps-0 meter-edit">
                                  <label className="ms-3">{accountname}</label>
                                </div>
                              </div>

                              <div class="col-md-6 mt-3">
                                <h6 className="text-blue total-flow-font-size ">
                                  End Date
                                </h6>
                                <div className="notification">
                                  <DatePicker
                                    className="pickdisplay w-100 px-2"
                                    getPopupContainer={(triggerNode) =>
                                      triggerNode.parentNode
                                    }
                                    presets={[
                                      {
                                        label: "Yesterday",
                                        value: dayjs().add(-1, "d"),
                                      },
                                      {
                                        label: "Last Week",
                                        value: dayjs().add(-7, "d"),
                                      },
                                      {
                                        label: "Last Month",
                                        value: dayjs().add(-1, "month"),
                                      },
                                    ]}
                                    disabledDate={(current) =>
                                      current &&
                                      current < dayjs().startOf("day")
                                    }
                                    value={
                                      date ? dayjs(date).startOf("day") : null
                                    }
                                    onChange={(d) => {
                                      if (d) {
                                        setdate(
                                          d.format("YYYY-MM-DD HH:mm:ss")
                                        );
                                      } else {
                                        setdate(null);
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        </Modal>
                      ) : (
                        ""
                      )}
                      <div class="col-md-4">
                          <div class="d-flex justify-content-start align-items-center gap-4">
                        <h6 className="total-flow-font-size mb-0">
                          <b>Audit Report</b>
                        </h6>
                        <Space className="me-3">
                                <Popover
                                  trigger="click"
                                  content={
                                    <div
                                      style={{
                                        width: "250px",
                                        textAlign: "left",
                                      }}
                                    >
                                    Enable to receive Audit Reports with detailed data in a comprehensive report format.
                                    </div>
                                  }
                                  placement="top"
                                  getPopupContainer={(trigger) =>
                                    trigger.parentElement
                                  }
                                >
                                  <InfoCircleOutlined
                                    onClick={(e) => e.stopPropagation()} 
                                    style={{
                                      color: "#1890ff",
                                      cursor: "pointer",
                                      marginTop: "8px",
                                    }}
                                  />
                                </Popover>
                              </Space>
                              </div>
                        <div class="form-check ps-0  d-flex align-items-center mt-3">
                          {weeklys === true ? (
                            <>
                              <Checkbox
                                checked={weeklys}
                                onChange={weeklyChanges}
                              >
                                <span className="ms-2">
                                  <b>Monthly</b>
                                </span>
                              </Checkbox>
                              <br />
                            </>
                          ) : (
                            <>
                              <Checkbox
                                checked={weeklys}
                                onChange={weeklyChanges}
                              >
                                <span className="ms-2">Monthly</span>
                              </Checkbox>
                              <br />
                            </>
                          )}
                          {monthlys === true ? (
                            <>
                              {" "}
                              <Checkbox
                                checked={monthlys}
                                onChange={monthlyChanges}
                              >
                                <span className="ms-2">
                                  <b>Yearly</b>
                                </span>
                              </Checkbox>
                              <br />
                            </>
                          ) : (
                            <>
                              <Checkbox
                                checked={monthlys}
                                onChange={monthlyChanges}
                              >
                                <span className="ms-2">Yearly</span>
                              </Checkbox>
                              <br />
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row m-0 notification-style">
                      <div className="col-lg-12">
                        {/* <h4 class="text-blue mb-0 fw-bold mb-3">Meter Settings</h4> */}
                        <h4 class="text-blue mb-0 fw-bold mb-3">
                          Meter Alerts
                        </h4>
                        <h6 className="w-100  total-flow-font-size">
                          <b>Mail Alerts</b>
                        </h6>
                        <div className="d-flex align-items-end justify-content-between mb-5">
                          <div className="d-flex align-items-center">
                            <div class="checkbox d-flex align-items-center me-4">
                              <input
                                type="radio"
                                value="daily"
                                id="daily"
                                className="specifyColor"
                                onChange={onActiveChange}
                                name="gender"
                                checked={checked === "daily"}
                              />
                              {checked === "daily" ? (
                                <span className="notificationstyle ms-2">
                                  <b>Daily Mail</b>
                                </span>
                              ) : (
                                <span className="notificationstyle ms-2">
                                  Daily Mail
                                </span>
                              )}
                            </div>
                            <div class="checkbox d-flex align-items-center me-4">
                              <input
                                type="radio"
                                value="weekly"
                                id="daily"
                                className="specifyColor"
                                onChange={onActiveChange}
                                name="gender"
                                checked={checked === "weekly"}
                              />
                              {checked === "weekly" ? (
                                <span className="notificationstyle ms-2">
                                  <b>Weekly Mail</b>
                                </span>
                              ) : (
                                <span className="notificationstyle ms-2">
                                  Weekly Mail
                                </span>
                              )}
                            </div>
                            <div class="checkbox d-flex align-items-center me-4">
                              <input
                                type="radio"
                                value="None"
                                id="daily"
                                className="specifyColor"
                                onChange={onActiveChange}
                                name="gender"
                                checked={checked === "None"}
                              />
                              {checked === "None" ? (
                                <span className="notificationstyle ms-2">
                                  <b>No Mail</b>
                                </span>
                              ) : (
                                <span className="notificationstyle ms-2">
                                  No Mail
                                </span>
                              )}
                            </div>
                          </div>
                          <button
                            className="btn btn-submit btn-sm mt-0"
                            onClick={modalclick}
                          >
                            Add Meter{" "}
                          </button>
                        </div>
                        <Table hover className="meter-table table">
                          <thead>
                            <tr>
                              <th>Meter</th>
                              <th>{isFB151 ? "ID" : "Account Name"}</th>
                              <th>End Date</th>
                              <th style={{ textAlign: "center" }}>Edit</th>
                              <th style={{ textAlign: "center" }}>Delete</th>
                            </tr>
                          </thead>
                          <tbody>
                            {datas && datas.length > 0
                              ? datas.map((row, i) => (
                                  <tr>
                                    <td>
                                      {row.meter_id}
                                      {row.register_number
                                        ? "," + row.register_number
                                        : ""}
                                    </td>
                                    <td>{row.account_name}</td>
                                    <td>{row.End_Date}</td>
                                    <td align="center">
                                      <img
                                        src={edit}
                                        alt="edit"
                                        style={{
                                          width: "25px",
                                          verticalAlign: "middle",
                                        }}
                                        onClick={() =>
                                          modalclicks(
                                            row.meter_id,
                                            row.account_name,
                                            row.register_number,
                                            row.End_Date
                                          )
                                        }
                                      />
                                    </td>
                                    <td align="center">
                                      <img
                                        src={deleteIcon}
                                        alt="delete"
                                        style={{
                                          width: "25px",
                                          verticalAlign: "middle",
                                        }}
                                        onClick={() =>
                                          handleDeleteClick(
                                            row.meter_id,
                                            row.register_number
                                          )
                                        }
                                      />
                                    </td>
                                  </tr>
                                ))
                              : null}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                    <div className="row m-0 notification-style mt-4">
                      <div className="col-lg-12">
                        {/* <h4 class="text-blue mb-0 fw-bold mb-3">Meter Settings</h4> */}
                        <div className="d-flex align-items-start justify-content-between">
                          <h4 class="text-blue mb-0 fw-bold mb-0">
                            {" "}
                            Water Usage Report{" "}
                          </h4>

                          <div className="d-flex align-items-end justify-content-end">
                            <div className="d-flex flex-column">
                              <div className="w-100 text-blue">Date Range </div>

                              <div className="selectCalender py-1 me-4 notify-date">
                                <Space
                                  direction="horizontal"
                                  size={1}
                                  className="custom-date anomaly-sty border-0"
                                >
                                  <RangePicker
                                    value={dates}
                                    onChange={onchangeMonthpicker}
                                    picker="month"
                                    format="MMM YYYY"
                                    separator={<SwapOutlined />}
                                  />
                                </Space>
                              </div>
                            </div>
                            {/*  */}
                            <div className="d-flex flex-column">
                              <div className="w-100 text-blue">
                                Day of Month
                              </div>
                              <div
                                class="d-flex selectCalender outliers-section"
                                style={{ boxShadow: "none", padding: "0" }}
                              >
                                <div
                                  class="fs-26 fw-bold d-flex outliers-select"
                                  style={{ minWidth: "165px" }}
                                >
                                  <select
                                    name="All meters"
                                    id="selector"
                                    value={aggregateValue}
                                    className="box border-0 w-100"
                                    onChange={onAggregateset}
                                    style={{
                                      padding: "9px 20px",
                                      height: "100%",
                                    }}
                                  >
                                    <option
                                      key={"0"}
                                      value="25"
                                      disabled
                                      selected
                                      hidden
                                    >
                                      {" "}
                                      25{" "}
                                    </option>
                                    {aggData.map((meter) => (
                                      <option key={meter} value={meter}>
                                        {" "}
                                        {meter}{" "}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                            {/*  */}

                            <div
                              class="fs-26 d-flex"
                              style={{ minWidth: "55px" }}
                            >
                              {startDownload === true && (
                                <Progress
                                  percent={progress}
                                  type="circle"
                                  className="progress-bar-style"
                                />
                              )}
                            </div>

                            <div
                              style={{
                                padding: "8px 16px",
                                background: "transparent",
                                fontSize: "17px",
                                border: "1px solid #cccccc",
                                borderRadius: "5px",
                                color: "#1976fd",
                                display: "block",
                              }}
                              className=""
                            >
                              <button
                                onClick={downclick}
                                style={{
                                  background: "none",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                              >
                                <img
                                  src={download}
                                  alt="Download CSV"
                                  style={{ width: "24px", height: "24px" }}
                                />{" "}
                                {csvData.length > 1 && startMonth && endMonth
                                  ? "Download"
                                  : "Download"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Main>
    </>
  );
}
export default Notificationss;
